<script>
    import config from '../libs/config.js';
    import Axios from 'axios'
    import AOS from 'aos'
    import api from '../api'
    import _ from 'lodash'
    import 'aos/dist/aos.css'

    import { mapGetters, mapActions } from 'vuex'

    export default {
        name: "onepageView",
        data(){
            return {
                loaded: false,
                notification: false
            }
        },
        computed: {
            ...mapGetters('mobileMenu', ['leftMobileMenu', 'rightMobileMenu'])
        },methods : {
            ...mapActions('mobileMenu', ['toggleLeftMenu','toggleRightMenu'])
        },
        created(){
            AOS.init();
            this.loaded = true
            console.log('No Auth');
        }
    }
    
</script>



<template>
<span>
        <div v-if="!loaded" data-aos="zoom-in" style="height:100%;" class="ui grid centered middle aligned stackable">
            <div class="six wide computer sixteen wide mobile column">
                <div class="ui basic segment center aligned">
                <div style="padding:0;" class="ui basic segment padded">
                <!-- <img class="ui image centered" style="width: 55px;" src="/img/logo.png" alt=""> -->
                </div>
                <div style="padding:0; color: #666;" class="ui basic segment">
                    Loading ...
                </div>
                <div class="loader-inner ball-beat"><div></div><div></div><div></div></div>
                </div>
            </div>
        </div>


        <div style="height: 100%;" class="ui stackable grid padded">
        <div v-if="leftMobileMenu || rightMobileMenu" @click="toggleRightMenu(false); toggleLeftMenu(false);" style="position: fixed; top: 0; right: 0; bottom: 0; left:0; background: rgba(15, 17, 26, 0.55) none repeat scroll 0% 0%; z-index: 122;"></div>
            <div style="background: #f9f9f9;" class="sixteen wide stretched column">
                <slot />
            </div>
        </div>

    </span>
</template>
<style>

</style>



// WEBPACK FOOTER //
// src/layouts/onepageViewNoAuth.vue